export enum ModuleType {
  Internal = 'INTERNAL',
  External = 'EXTERNAL',
}

export enum ModuleCode {
  DigitalSignature = 'DIGITAL_SIGNATURE',
  EBilling = 'EBILLING',
  DocumentManagement = 'DOCUMENT_MANAGEMENT',
  DigitalMailbox = 'DIGITAL_MAILBOX',
  ConsentManagement = 'CONSENT_MANAGEMENT',
  SystemSetting = 'SYSTEM_SETTING',
  EPaymentConfig = 'E_PAYMENT_CONFIG',
  PrintAndPost = 'PRINT_AND_POST',
  Helpdesk = 'HELPDESK',
  PublicRelation = 'PUBLICRELATION',
  AdminDashboard = 'ADMIN_DASHBOARD',
  ConfigBill = 'CONFIG_BILL',
  MyService = 'MY_SERVICE',
}

export interface IModuleConfig {
  code: ModuleCode;
  name: string;
  imagePath: string;
  urlPath: string;
  type: ModuleType;
  permissions?: string[];
  useApiConfigValue: boolean;
  serviceCode?: string;
  description?: string;
  submenu?: ModuleSubMenu[];
}

export interface IExternalLinkConfig {
  signingHub: string;
}

export class ModuleSubMenu {
  id: number
  name: string
  url: string 
}
